import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainAgitation() {
  const beliefs = [{
    myth: 'El cansancio es el precio del éxito',
    truth: 'Tu cansancio es inflamación crónica medible y reversible'
  }, {
    myth: 'Ganar 5 kilos al año es inevitable a los 40',
    truth: 'Es el resultado de aceites industriales y timing nutricional incorrecto'
  }, {
    myth: 'Olvidar nombres es solo estrés',
    truth: 'Es degradación de la corteza prefrontal por cortisol crónico'
  }, {
    myth: 'El crash de las 3 PM es normal',
    truth: 'Es tu glucosa en montaña rusa por dependencia de carbohidratos simples'
  }];
  return <section className="py-24 px-6 bg-brand-bg" data-id="element-488">
      <div className="max-w-[700px] mx-auto" data-id="element-489">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-490">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-491">
            La Mayoría de los Ejecutivos Exitosos Están Cometiendo un Error
            Fatal
          </h2>
          <p className="text-xl text-brand-muted" data-id="element-492">
            Están canjeando su salud por su carrera.
          </p>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-493">
          {beliefs.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} className="bg-brand-card rounded-[20px] p-6 border border-brand-border shadow-sm" data-id="element-494">
              <div className="flex items-start gap-4" data-id="element-495">
                <div className="mt-1 bg-brand-red/10 p-1.5 rounded-full shrink-0" data-id="element-496">
                  <X className="w-5 h-5 text-brand-red" data-id="element-497" />
                </div>
                <div data-id="element-498">
                  <p className="text-brand-muted line-through mb-2" data-id="element-499">
                    "{item.myth}"
                  </p>
                  <p className="text-white font-medium" data-id="element-500">→ {item.truth}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="relative p-[1px] rounded-2xl bg-gradient-to-r from-brand-red to-brand-purple" data-id="element-501">
          <div className="bg-brand-bg rounded-2xl p-8 text-center" data-id="element-502">
            <p className="text-lg text-white leading-relaxed" data-id="element-503">
              Tu cuerpo está en un estado de{' '}
              <strong className="text-brand-red" data-id="element-504">inflamación crónica</strong>.
              Tus mitocondrias — las pilas de tus células — se están apagando.
              Si no detienes este proceso AHORA, no importa cuánto dinero ganes:
              no tendrás la vitalidad para disfrutarlo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}